import { render, staticRenderFns } from "./menuMobile.vue?vue&type=template&id=65f65e66"
import script from "./menuMobile.vue?vue&type=script&lang=js"
export * from "./menuMobile.vue?vue&type=script&lang=js"
import style0 from "./menuMobile.vue?vue&type=style&index=0&id=65f65e66&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports